import accounting from 'accounting';

accounting.settings.number = {
  precision: 2,
  decimal: ',',
  thousand: ' ',
};

export const formatNumber = (n: number, precision = 0) => accounting.formatNumber(n, precision);
